class TooltipDemo extends React.Component {
  constructor() {
    super();

  }


  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="tooltip">
          Tooltip
          <span className="section__item-docs">
            Documentation:&nbsp;
            <a href="docs/components/class/components/Tooltip.jsx~Tooltip.html" target="_blank">JS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Modals</h4>
              <div className="demo__code">
                <CodeBlock lang="jsx">
                {`
@import {Tooltip} from 'airtame-gooey';

...

render() {
  return (
    <div className="tooltip-demo">
      <div>
        <Tooltip title="Hover me!" className="demo-tooltip">
          Don't you love it how I open on hover?
        </Tooltip>
      </div>
      <div>
        <Tooltip title="I'm an icon!" className="icon-tooltip">
          You should love this even more!
        </Tooltip>
      </div>
      <div>
        <Tooltip title="I'm an icon!" className="icon-tooltip-b">
          You should love this even more!
        </Tooltip>
      </div>
      <div>
        <Tooltip title="I'm an icon!" className="icon-tooltip-l">
          You should love this even more!
        </Tooltip>
      </div>
    </div>
  )
}

                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.tooltip-demo {
  .demo-tooltip {
    @include tooltip();
  }

  .icon-tooltip {
    @include tooltip($bubble-position: right, $icon: warning);

    .tooltip__title:before {
      color: $apricot;
    }
  }

  .icon-tooltip-b {
    @include tooltip($bubble-position: bottom, $icon: bars);

    .tooltip__title:before {
      color: $lipstick;
    }
  }

  .icon-tooltip-l {
    @include tooltip($bubble-position: left, $icon: check);

    .tooltip__title:before {
      color: $weird-green;
    }
  }
}


                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="tooltip-demo">
                    <div>
                      <Tooltip title="Hover me!" className="demo-tooltip">
                        Don't you love it how I open on hover?
                      </Tooltip>
                    </div>
                    <div>
                      <Tooltip title="I'm an icon!" className="icon-tooltip">
                        You should love this even more!
                      </Tooltip>
                    </div>
                    <div>
                      <Tooltip title="I'm an icon!" className="icon-tooltip-b">
                        You should love this even more!
                      </Tooltip>
                    </div>
                    <div>
                      <Tooltip title="I'm an icon!" className="icon-tooltip-l">
                        You should love this even more!
                      </Tooltip>
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
